
import { defineComponent } from "vue";
import statsCard from "@/components/stats-card.vue";

export default defineComponent({
  name: "stats",
  components: {
    statsCard,
  },
});
